

















































import Vue from 'vue';
import Component from 'vue-class-component';
import { validationMixin } from 'vuelidate';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import Box from '@/components/Box.vue';
import { Action, namespace } from 'vuex-class';
import userService from '@sone/sone-frontend-core/src/services/HttpService';

const oidcStore = namespace('oidc');

@Component({
  components: {
    Box,
  },
  layout: 'unauthenticated',
  mixins: [validationMixin],
  validations: {
    form: {},
  }
})
export default class UnblockUserPage extends Vue {
  public form = { code: null, subject: null };
  public error: any = false;
  public action = '';
  public paramError = false;
  public loading = false;
  public success = false;

  public created() {
    this.form.code = this.getPropertyCaseInsensitive(this.$route.query, 'code');
    this.form.subject = this.getPropertyCaseInsensitive(this.$route.query, 'subject');
    if (this.$route && this.$route.query && (!this.form.code || !this.form.subject) ) {
      this.paramError = true;
    }
  }

  public getValidationClass(fieldName: string) {
    const field = (this.$v.form as any)[fieldName];
    if (field) {
      return {
        'md-invalid': field.$invalid && field.$dirty,
      };
    }
  }

  public validateUnblockUser(event: any) {
    this.$v.$touch();
    if (!this.$v.$invalid) {
        this.loading = true;

        this.$axios
          .post(`${process.env.VUE_APP_AUTH_URL}api/v1/Access/UnlockUser`, {
            Subject: this.form.subject,
            Code: this.form.code
            })
          .then(
            () => {
              this.loading = false;
              this.error = null;
              this.success = true;
            },
            (error: any) => {
              this.error = error;
              this.loading = false;
            }
          );
    }
  }
  public goToLogin() {
      this.$router.push('sign-in');
    }
  private getPropertyCaseInsensitive(object, key) {
    return object[Object.keys(object)
      .find((k) => k.toLowerCase() === key.toLowerCase())
    ];
  }

}
